<template >
  <div>
    <div>
      <van-cell-group>
        <van-cell :title="generateCustomizeString('addExpressNo')" icon="logistics">
          <van-icon
            slot="right-icon"
            name="add-o"
            class="van-cell__right-icon"
            style="font-size: 16px; color: #38f;"
            @click="addExpress()"
          />
        </van-cell>
      </van-cell-group>
      <template v-for="(express, index) in expresses">
        <van-cell-group :key="express.express_company_id">
          <van-cell
            @click="clickCompany(index)"
            v-model="express.express_company.name"
            :title="generateCustomizeString('expressCompany')"
            is-link
          />
          <van-field
            v-model="express.express_number"
            type="textarea"
            autosize
            :placeholder="generateCustomizeString('expressNoPlaceHolder')"
            icon="close"
            @click-icon="deleteExpress(index)"
          ></van-field>
          <van-button
            size="large"
            @click="clickExpressScan(index)"
          >{{generateCustomizeString('scanExpressCode')}}</van-button>
        </van-cell-group>
      </template>
    </div>
    <div style="margin-top: 5px; padding-bottom: 5px; border-radius: 3px; background: #fff;">
      <van-cell-group>
        <van-cell :title="generateCustomizeString('uploadImg')" icon="photo"></van-cell>
      </van-cell-group>
      <div style="width: 100%;" v-if="imageList.length > 0">
        <template v-for="(img, index) in imageList">
          <div :key="'div' + img">
            <van-icon
              name="close"
              style="float: right; font-size: 16px; color: #929292; margin: 5px 5px;"
              @click="deleteImg(index)"
            />
            <img v-lazy="img" :key="img" style="width: 100%;" />
          </div>
        </template>
      </div>
      <div style="margin: 20px; text-align: center;">
        <van-uploader :after-read="onRead">
          <span style="font-size: 20px; line-height: 26px; vertical-align: middle; color: #38f;">
            <van-icon name="upgrade" style="margin-top: 3px; " />
          </span>
          <span
            style="margin-left: 5px; line-height: 26px; font-size: 16px; color: #38f;"
          >{{generateCustomizeString('clickUpload')}}</span>
        </van-uploader>
      </div>
    </div>
    <van-actionsheet
      v-model="showCompany"
      :actions="expressCompanyOptions"
      @select="selectCompany"
      :cancel-text="generateCustomizeString('cancel')"
    />
    <!-- <div style="position: fixed; bottom: 0; width: 100%;">
      <van-button type="primary" size="large" @click="orderOperation">更新订单</van-button>
    </div>-->
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import {
  Row,
  Col,
  Uploader,
  Icon,
  Button,
  Cell,
  CellGroup,
  Actionsheet,
  Field,
  Lazyload,
  Toast,
  Dialog,
  Popup,
  Loading
} from 'vant'
import compressor from '@/utils/compressor'
import axios from 'axios'
import store from '@/store'
import wxConfig from '@/utils/wxConfig'
import request from '@/utils/request'

export default {
  name: 'OrderOperation',
  components: {
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Actionsheet.name]: Actionsheet,
    [Field.name]: Field,
    [Lazyload.name]: Lazyload,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Popup.name]: Popup,
    [Loading.name]: Loading
  },
  data() {
    return {
      companyId: null,
      showCompany: false,
      expressNumber: '',
      expressCompany: '',
      expresses: [],
      imageKeys: [],
      currentSelectIndex: 0,
      loading: false,
      testKey: wxConfig.expressCode,
      currentExpressIndex: null
    }
  },
  computed: {
    imageList: function() {
      return this.imageKeys.map(key => 'https://img.nzmai.com.cn/' + key)
    }
  },
  props: {
    expressCompanyOptions: {
      type: Array,
      default: () => []
    },
    orderExpressData: {
      type: Array,
      default: () => []
    },
    orderDetailData: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    generateCustomizeString,
    clickCompany(index) {
      this.currentSelectIndex = index
      this.showCompany = true
    },
    clickExpressScan(index) {
      const that = this
      if (that.expresses[index].express_number === undefined) {
        that.expresses[index].express_number = ''
      }

      wxConfig.scanQRCode().then(key => {
        if (
          that.expresses[index].express_number &&
          that.expresses[index].express_number.length > 0
        ) {
          that.expresses[index].express_number =
            that.expresses[index].express_number + ',' + key
        } else {
          that.expresses[index].express_number = key
        }
      })
      // wxConfig.scanCode(function(res) {
      //   const result = res.resultStr
      //   const resultArr = result.split(',')
      //   const key = resultArr[1]
      //   if (
      //     that.expresses[index].express_number &&
      //     that.expresses[index].express_number.length > 0
      //   ) {
      //     that.expresses[index].express_number =
      //       that.expresses[index].express_number + ',' + key
      //   } else {
      //     that.expresses[index].express_number = key
      //   }
      // })
    },
    selectCompany(item) {
      const companyId = item.value
      const companyName = item.name
      this.expresses[this.currentSelectIndex].express_company_id = companyId
      this.expresses[this.currentSelectIndex].express_company.name = companyName
      this.showCompany = false
    },
    addExpress() {
      this.expresses.push({
        express_company_id: '',
        express_number: '',
        express_company: {
          name: ''
        }
      })
      for (var i = 0; i < this.expressCompanyOptions.length; i++) {
        if (
          this.expressCompanyOptions[i].is_default === 1 &&
          this.expresses.length === 1
        ) {
          this.expresses[0].express_company.name = this.expressCompanyOptions[
            i
          ].name
          this.expresses[0].express_company_id = this.expressCompanyOptions[
            i
          ].value
        }
      }
      console.log(this.expresses)
    },
    deleteExpress(index) {
      this.expresses.splice(index, 1)
    },
    deleteImg(index) {
      Dialog.confirm({
        message: this.generateCustomizeString('confirmDeleteImage') + '?',
        confirmButtonText: this.generateCustomizeString('confirm'),
        cancelButtonText: this.generateCustomizeString('cancel')
      })
        .then(() => {
          Toast.loading({
            mask: true,
            forbidClick: true,
            message: this.generateCustomizeString('deletingImg')
          })
          var copyImageKeys = this.imageKeys.slice()
          copyImageKeys.splice(index, 1)

          var data = {
            upload_image_keys: copyImageKeys
          }
          console.log(data)
          request({
            url: 'order/' + this.orderDetailData.id + '/order-images',
            method: 'put',
            data
          })
            .then(response => {
              if (response.status === 0) {
                Toast.clear()
                Toast.success(this.generateCustomizeString('deleteImgSuccess'))
                this.imageKeys = copyImageKeys
              } else {
                Toast.clear()
                Toast.fail(this.generateCustomizeString('deleteImgFail'))
              }
            })
            .catch(error => {
              console.log(error)
              Toast.clear()
              Toast.fail(this.generateCustomizeString('deleteImgFail'))
            })
        })
    },
    uploadImageToQiniu(data) {
      return new Promise((resolve, reject) => {
        const axiosInstance = axios.create({})
        axiosInstance({
          url: 'https://upload-z2.qiniup.com',
          method: 'POST',
          data: data
        })
          .then(response => {
            this.imageKeys.push(response.data.key)
            resolve()
          })
          .catch(error => {
            Toast.fail(this.generateCustomizeString('uploadImgFail'))
            console.log(error)
            reject(error)
            // that.loading = false
          })
      })
    },
    updateImageKeyToApiSever() {
      return new Promise((resolve, reject) => {
        var data = {
          upload_image_keys: this.imageKeys
        }
        console.log(data)
        request({
          url: 'order/' + this.orderDetailData.id + '/order-images',
          method: 'put',
          data
        })
          .then(response => {
            if (response.status === 0) {
              Toast.clear()
              Toast.success(this.generateCustomizeString('saveImgSuccess'))
            } else {
              this.imageKeys.pop()
              Toast.clear()
              Toast.fail(this.generateCustomizeString('saveImgFail'))
            }
            resolve()
          })
          .catch(error => {
            this.imageKeys.pop()
            console.log(error)
            Toast.clear()
            Toast.fail(this.generateCustomizeString('saveImgFail'))
            reject(error)
          })
      })
    },
    onRead(fileData) {
      // const that = this
      // this.loading = true
      Toast.loading({
        mask: true,
        forbidClick: true,
        message: this.generateCustomizeString('uploadingImg')
      })

      compressor.image(fileData.file).then(file => {
        store
          .dispatch('GetQiNiuUploadToken')
          .then(token => {
            var data = new FormData()
            data.append('token', token)
            data.append('file', file)
            this.uploadImageToQiniu(data)
              .then(response => {
                this.updateImageKeyToApiSever()
              })
              .catch(error => {
                Toast.fail(this.generateCustomizeString('uploadQiniuFail'))
                console.log(error)
              })
          })
          .catch(error => {
            Toast.fail(this.generateCustomizeString('getTokenFail'))
            console.log(error)
          })
      })
    },
    initialExpresses() {
      for (var i = 0; i < this.orderExpressData.length; i++) {
        var obj = {
          express_company_id: this.orderExpressData[i].expressCompanyId
            ? this.orderExpressData[i].expressCompanyId
            : '',
          express_number: this.orderExpressData[i].expressNumber
            ? this.orderExpressData[i].expressNumber
            : '',
          express_company: {
            name: this.orderExpressData[i].expressCompany
              ? this.orderExpressData[i].expressCompany
              : ''
          }
        }
        this.expresses.push(obj)
      }
      for (var j = 0; j < this.orderDetailData.images.length; j++) {
        this.imageKeys.push(this.orderDetailData.images[j].qiniu_res_key)
        // this.imageKeysCopy.push(this.orderDetailData.images[j].qiniu_res_key)
      }
      console.log(this.expresses)
    }
  },
  created: function() {
    console.log(this.orderExpressData)
    this.initialExpresses()
    // wxConfig.config()
  },
  watch: {
    testKey: function(newKey, oldKey) {
      Toast.success(newKey)
      if (this.currentExpressIndex !== null) {
        const index = this.currentExpressIndex
        if (
          this.expresses[index].express_number &&
          this.expresses[index].express_number.length > 0
        ) {
          this.expresses[index].express_number =
            this.expresses[index].express_number + ',' + newKey
        } else {
          this.expresses[index].express_number = newKey
        }
      }
      this.currentExpressIndex = null
    }
  }
}
</script>

<style lang="less" scoped>
</style>
